<template>
  <div class="bancos-movimientos-list">
    <transition name="slide">
      <b-row>
        <b-col cols="12" xl="12">
          <b-card header="Cuenta" class="card-filter">
            <b-btn class="filter-collapse" 
                variant="primary" 
                size="sm"
                @click.prevent="showOpcionesFiltro= !showOpcionesFiltro">
              <i :class="showOpcionesFiltro ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
            </b-btn>
            <b-collapse id="filtro" class="mt-2" v-model="showOpcionesFiltro">
              <b-form>
                <app-banco-cuenta
                  label="Cuenta"
                  :nombre="bancoCuentaSeleccionNombre"
                  :lista="bancosCuentasList"
                  :labelCols="labelCols"
                  @updated="bancoCuentaActualizada"
                  v-if="seleccionBancoCuenta">
                </app-banco-cuenta>

                <b-form-group
                  label="Cuenta"
                  label-for="cuenta"
                  :label-cols="labelCols"
                  horizontal
                  v-if="!seleccionBancoCuenta">
                  <b-form-input 
                    :value="bancoCuentaNombre"
                    readonly
                    type="text"/>
                </b-form-group>

                <b-form-group
                  label="Desde"
                  :label-cols="labelCols"
                  horizontal>
                  <b-input-group>
                    <b-form-input 
                      v-model= "seleccion.fechaDesde" 
                      type="date"
                      v-if="seleccionBancoCuenta">
                    </b-form-input>
                    <b-form-input 
                      :value= "fechaDesdeSeleccionada | fecha" 
                      readonly
                      type="text"
                      v-if="!seleccionBancoCuenta">
                    </b-form-input>
                  </b-input-group>
                </b-form-group>

                <b-form-group
                  label="Hasta"
                  :label-cols="labelCols"
                  horizontal>
                  <b-input-group>
                    <b-form-input 
                      v-model= "seleccion.fechaHasta" 
                      type="date"
                      v-if="seleccionBancoCuenta">
                    </b-form-input>
                    <b-form-input 
                      :value= "fechaHastaSeleccionada | fecha" 
                      readonly
                      type="text"
                      v-if="!seleccionBancoCuenta">
                    </b-form-input>
                  </b-input-group>
                </b-form-group>

                <app-banco-movimiento-tipo
                  label="Tipo de Movimiento"
                  :nombre="bancoMovimientoTipoSeleccionNombre"
                  :lista="bancosMovimientosTiposList"
                  :labelCols="labelCols"
                  :nullDisabled="false"
                  @updated="bancoMovimientoTipoActualizado"
                  v-if="seleccionBancoCuenta">
                </app-banco-movimiento-tipo>

                <b-form-group
                  label="Tipo de Movimiento"
                  label-for="bancoMovimientoTipo"
                  :label-cols="labelCols"
                  horizontal
                  v-if="!seleccionBancoCuenta">
                  <b-form-input 
                    :value="bancoMovimientoTipoNombre"
                    readonly
                    type="text"/>
                </b-form-group>

                <div slot="footer">
                  <b-button size="sm" variant="primary" class="footer-button" v-if="!seleccionBancoCuenta"
                    @click.prevent="seleccionarOpciones">Seleccionar</b-button>
                  <!-- <b-button size="sm" variant="primary" class="footer-button" v-if="!seleccionBancoCuenta & bancoCuentaId != 0"
                    @click.prevent="actualizarCierre">Actualizar Cierre</b-button> -->
                  <b-button size="sm" variant="primary" class="footer-button" v-if="seleccionBancoCuenta"
                    @click.prevent="aceptarSeleccion">Aceptar</b-button>
                  <b-button size="sm" variant="danger" class="footer-button" v-if="seleccionBancoCuenta"
                    @click.prevent="cancelarSeleccion">Cancelar</b-button>
                </div>
              </b-form>
            </b-collapse>
          </b-card>
          
          <b-card :header="titulo">
            <b-table hover
                responsive="sm" 
                class="registro"
                :busy="tableBusy"
                :items="bancosMovimientos" 
                :fields="bancosMovimientosFields" 
                @row-clicked="consultar">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>              
              <template v-slot:cell(fechaCreditoDebito)="data">
                {{ data.item.fechaCreditoDebito | fecha }}
              </template>
              <template v-slot:cell(numero)="data">
                {{ data.item.numero }}
              </template>
              <template v-slot:cell(debe)="data">
                {{ data.item.debe | moneda(bancoCuentaMoneda) }}
              </template>
              <template v-slot:cell(haber)="data">
                {{ data.item.haber | moneda(bancoCuentaMoneda) }}
              </template>
              <template v-slot:cell(importe)="data">
                {{ data.item.importe | moneda(bancoCuentaMoneda) }}
              </template>
              <template v-slot:cell(saldoAcumulado)="data">
                <template v-if="bancoMovimientoTipoId != 0 || !data.item.acumulaSaldo">
                  ---.--
                </template>
                <template v-if="bancoMovimientoTipoId == 0 && data.item.acumulaSaldo">
                  {{ data.item.saldoAcumulado | moneda(bancoCuentaMoneda) }}
                </template>
              </template>
              <template v-slot:cell(conciliado)="data">
                {{ data.item.conciliado ? 'Si' : 'No' }}
              </template>
              <template v-slot:cell(opciones)="data">
                <template v-if="movimientosSeleccionados.length != 0 && !data.item.readonly">
                  <b-form-checkbox
                      v-model="data.item.selected"
                      v-if="!data.item.conciliado"
                      :value="Boolean(true)"
                      :unchecked-value="Boolean(false)"
                      @change="actualizarSeleccion(data.item)">
                  </b-form-checkbox> 
                </template>

                <template v-if="movimientosSeleccionados.length == 0 && !data.item.readonly">
                  <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                    <template slot="button-content">
                      <i class="fa fa-ellipsis-v"></i>
                    </template>
                    <b-dropdown-item 
                        v-if="!data.item.conciliado"
                        @click.stop="conciliar(data.item)">
                      <i class="fa fa-check"></i>Conciliar Movimiento</b-dropdown-item>
                    <b-dropdown-item 
                        v-if="data.item.conciliado"
                        @click.stop="anularConciliacion(data.item)">
                      <i class="fa fa-remove"></i>Anular Conciliación del Movimiento</b-dropdown-item>
                    <b-dropdown-item 
                        v-if="data.item.bancoMovimientoTipoId == 1"
                        @click.stop="devolver(data.item)">
                      <i class="fa fa-undo"></i>Devolver Cheque</b-dropdown-item>
                    <b-dropdown-item 
                      v-if="!data.item.conciliado"
                      @click.stop="editar(data.item)">
                      <i class="fa fa-edit"></i>Editar Movimiento</b-dropdown-item>
                    <b-dropdown-item 
                      v-if="!data.item.conciliado"
                      @click.stop="borrar(data.item)">
                      <i class="fa fa-remove"></i>Borrar Movimiento</b-dropdown-item>

                    <b-dropdown-item 
                        v-if="!data.item.conciliado"
                        @click.stop="seleccionarMovimiento(data.item)">
                      <i class="fa fa-check"></i>Seleccionar Movimiento</b-dropdown-item>
                  </b-dropdown>
                </template>
              </template>
            </b-table>
            <nav>
              <b-pagination size="sm" 
                :total-rows="totalRegistros" 
                :per-page="registrosPorPagina" 
                v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
            </nav>
          </b-card>
        </b-col>
      </b-row>
    </transition>
    
    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item 
              v-if="movimientosSeleccionados.length != 0"
              @click.stop="conciliarMovimientos">
            <i class="fa fa-check"></i>Conciliar Movimientos</b-dropdown-item>
          <b-dropdown-item 
              v-if="movimientosSeleccionados.length != 0"
              @click.stop="cancelarSeleccionMovimientos">
            <i class="fa fa-remove"></i>Cancelar Selección</b-dropdown-item>

          <b-dropdown-item 
              v-if="movimientosSeleccionados.length == 0"
              @click.stop="agregar"
              :disabled="!bancoCuenta">
            <i class="fa fa-plus"></i>Nuevo Movimiento</b-dropdown-item>
          <b-dropdown-item 
              v-if="movimientosSeleccionados.length == 0"
              @click.stop="agregarTransferencia"
              :disabled="!bancoCuenta">
            <i class="fa fa-exchange"></i>Transferencia entre Cuentas</b-dropdown-item>
          <b-dropdown-item 
              v-if="movimientosSeleccionados.length == 0"
              @click.stop="agregarTransferenciaPremios"
              :disabled="!bancoCuenta || bancoCuentaMonedaId != 101">
            <i class="fa fa-exchange"></i>Transferencia por Premios</b-dropdown-item>
          <b-dropdown-item 
              v-if="movimientosSeleccionados.length == 0"
              @click.stop="agregarCompraVentaDivisas"
              :disabled="!bancoCuenta">
            <i class="fa fa-exchange"></i>Compra/Venta de Divisas</b-dropdown-item>
          <b-dropdown-item 
              v-if="movimientosSeleccionados.length == 0"
              @click.stop="anularDevolucion"
              :disabled="!bancoCuenta">
            <i class="fa fa-remove"></i>Anular Devolución de Cheque</b-dropdown-item>
          <b-dropdown-item 
              v-if="movimientosSeleccionados.length == 0"
              @click.stop="saldoCuenta"
              :disabled="!bancoCuenta">
            <i class="fa fa-usd"></i>Consultar Saldo de la Cuenta</b-dropdown-item>
          <b-dropdown-item 
              v-if="movimientosSeleccionados.length == 0"
              @click.stop="actualizarCierre"
              :disabled="!bancoCuenta">
            <i class="fa fa-lock"></i>Actualizar cierre de cuenta</b-dropdown-item>
          <b-dropdown-item 
              v-if="movimientosSeleccionados.length == 0"
              @click.stop="exportarLibroBanco"
              :disabled="!bancoCuenta">
            <i class="fa fa-file-excel-o"></i>Exportar Libro Banco</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>

    <b-modal ref="movimientoModal"
        title="Movimiento de Banco"
        modal-class="modalABM"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-alta-movimiento
        :bancoMovimientoId="bancoMovimientoSeleccionadoId"
        :cuenta="bancoCuenta"
        @updateMovimientos="updateMovimientos"
        @closeMovimiento="closeMovimiento">
      </app-alta-movimiento>  
    </b-modal>

    <b-modal ref="cierreModal"
        title="Cierre de Movimientos"
        modal-class="modalABM"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-cierre
        :bancoCuentaId="bancoCuentaId"
        :modal="true"
        @cierreActualizado="closeCierres"
        @close="closeCierres">
      </app-cierre>  
    </b-modal>

    <b-modal ref="conciliacionModal"
        title="Conciliar Movimiento"
        modal-class="modalABM"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-conciliacion
        :bancoMovimientoId="bancoMovimientoId"
        :fechaCreditoDebitoActual="fechaCreditoDebito"
        @movimientoConciliado="movimientoConciliado"
        @close="closeConciliacion">
      </app-conciliacion>  
    </b-modal>

    <b-modal ref="transferenciaCuentasModal"
        title="Transferencia entre Cuentas"
        modal-class="modalABM"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-transferencia-cuentas
        :cuenta="bancoCuenta"
        @close="closeTransferencia">
      </app-transferencia-cuentas>  
    </b-modal>

    <b-modal ref="transferenciaPremiosModal"
        title="Transferencia Premios"
        modal-class="modalABM"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-transferencia-premios
        :cuenta="bancoCuenta"
        @close="closeTransferenciaPremios">
      </app-transferencia-premios>  
    </b-modal>

    <b-modal ref="anulacionDevolucionModal"
        title="Anular Devolución"
        modal-class="modalABM"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-anulacion-devolucion
        :bancoCuentaId="bancoCuentaId"
        @close="closeAnulacionDevolucion">
      </app-anulacion-devolucion>  
    </b-modal>

    <b-modal ref="compraVentaDivisasModal"
        title="Compra/Venta de Divisas"
        modal-class="modalABM"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-compra-venta-divisas
        :cuenta="bancoCuenta"
        @close="closeCompraVentaDivisas">
      </app-compra-venta-divisas>  
    </b-modal>
  </div>
</template>

<script>
import BancoCuenta from '../shared/abmSelect.vue';
import BancoMovimientoTipo from '../shared/abmSelect.vue';
import AltaMovimiento from './ABM.vue';
import Cierre from '../bancoscuentas/Cierre.vue';
import Conciliacion from './Conciliacion.vue';
import TransferenciaCuentas from './TransferenciaCuentas.vue';
import TransferenciaPremios from './TransferenciaPremios.vue';
import AnulacionDevolucion from './AnulacionDevolucion.vue';
import CompraVentaDivisas from './CompraVentaDivisas.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'bancosmovimientos/getField',
  mutationType: 'bancosmovimientos/updateField',
});

export default {
  name: 'BancosMovimientos',
  components: {
    appBancoCuenta: BancoCuenta,
    appBancoMovimientoTipo: BancoMovimientoTipo,
    appAltaMovimiento: AltaMovimiento,
    appCierre: Cierre,
    appConciliacion: Conciliacion,
    appTransferenciaCuentas: TransferenciaCuentas,
    appTransferenciaPremios: TransferenciaPremios,
    appAnulacionDevolucion: AnulacionDevolucion,
    appCompraVentaDivisas: CompraVentaDivisas,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  data: () => {
    return {
      bancosMovimientosFields: [
        { 
          key: 'fechaCreditoDebito',
          label: 'Fecha Cred./Deb.'
        },
        /*{ key: 'bancoCuenta' },*/
        { 
          key: 'bancoMovimientoTipo', 
          label: 'Tipo de Movimiento'
        },
        {
          key: 'numero',
          class: 'text-right',
        },
        {
          key: 'haber',
          label: 'Débitos',
          class: 'text-right',
        },
        {
          key: 'debe',
          label: 'Créditos',
          class: 'text-right',
        },
        {
          key: 'haber',
          label: 'Créditos',
          class: 'text-right',
        },
        // {
        //   key: 'importe',
        //   class: 'text-right',
        // },
        {
          key: 'saldoAcumulado',
          label: 'Saldo',
          class: 'text-right',
        },
        {
          key: 'conciliado',
          class:'text-center'
        },
        {
          key: 'opciones',
          label: '',
          class:'text-center'
        },
      ],

      tableBusy: false,
      showOpcionesFiltro: false,
      labelCols: 2,

      bancoMovimientoSeleccionado: null,
      bancoMovimientoSeleccionadoId: 0,

      seleccionBancoCuenta: false,
      bancosCuentas: [],
      bancosCuentasList: [],
      bancosMovimientosTipos: [],
      bancosMovimientosTiposList: [],

      seleccion: {
        bancoCuenta: null,
        fechaDesde: new Date(),
        fechaHasta: new Date(),
        bancoMovimientoTipo: null,
      }
    }
  },
  computed: {
    ...mapFields([
      'bancosMovimientos',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'bancoCuenta',
      'fechaDesde',
      'fechaHasta',
      'bancoMovimientoTipo',
      'empresaId',

      'movimientosSeleccionados'
    ]),
    titulo: function() {
      return this.bancoCuenta ? 'Libro Banco - ' + this.bancoCuenta.nombre.trim() : 'Libro Banco';
    },
    bancoCuentaId: function() {
      return this.bancoCuenta ? this.bancoCuenta.id : 0;
    },
    bancoCuentaNombre: function() {
      return this.bancoCuenta ? this.bancoCuenta.nombre.trim() : '';
    },
    bancoCuentaMonedaId: function() {
      return this.bancoCuenta ? this.bancoCuenta.monedaId : 0;
    },
    bancoCuentaMoneda: function() {
      return this.bancoCuenta ? this.bancoCuenta.moneda.trim() : '';
    },
    fechaDesdeSeleccionada: function() {
      return this.bancoCuenta ? this.fechaDesde : '1900-01-01';
    },
    fechaHastaSeleccionada: function() {
      return this.bancoCuenta ? this.fechaHasta : '1900-01-01';
    },
    bancoMovimientoTipoId: function() {
      return this.bancoMovimientoTipo ? this.bancoMovimientoTipo.id : 0;
    },
    bancoMovimientoTipoNombre: function() {
      return this.bancoMovimientoTipo ? this.bancoMovimientoTipo.nombre.trim() : '';
    },

    bancoCuentaSeleccionNombre: function() {
      return this.seleccion.bancoCuenta ? this.seleccion.bancoCuenta.nombre : null;
    },
    bancoMovimientoTipoSeleccionNombre: function() {
      return this.seleccion.bancoMovimientoTipo ? this.seleccion.bancoMovimientoTipo.nombre : null;
    },

    bancoMovimientoId: function() {
      return this.bancoMovimientoSeleccionado ? this.bancoMovimientoSeleccionado.id : 0;
    },
    fechaCreditoDebito: function() {
      let fecha = new Date();
      if (this.bancoMovimientoSeleccionado) {
        fecha = this.bancoMovimientoSeleccionado.fechaCreditoDebito;
      }
      return moment(fecha).format('YYYY-MM-DD');
      // return this.bancoMovimientoSeleccionado ? this.bancoMovimientoSeleccionado.fechaCreditoDebito : new Date();
    },

    // bancosMovimientosSeleccionados() {
    //   if (this.bancosMovimientos) {
    //     if (this.bancosMovimientos.length != 0) {
    //       return this.bancosMovimientos.filter(bancoMovimiento => bancoMovimiento.selected);
    //     }
    //   }

    //   return null;
    // },
  },
  created() {
    /* Si la empresa actual no corresponde a la empresa de los movimientos */
    if (this.empresaId != this.$store.getters['user/empresaId']) {
      this.$store.dispatch('bancosmovimientos/inicializarParametros')
    }

    if (!this.bancoCuenta) {
      this.showOpcionesFiltro = true;
    }

    this.getDatosAdicionales();
    this.getBancosMovimientos();
  },
  methods: {
    getBancosMovimientos(clearMovimientosSeleccionados) {
      let params = {
        clearMovimientosSeleccionados: false
      };
      
      if (clearMovimientosSeleccionados) {
        params.clearMovimientosSeleccionados = true;
      }

      this.tableBusy = true;
      this.$store.dispatch('bancosmovimientos/getBancosMovimientos', params)
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    getDatosAdicionales(){
      const vm = this

      this.$store.dispatch('bancoscuentas/getList')
        .then(() => {
          vm.bancosCuentas = this.$store.getters['bancoscuentas/list']
          vm.bancosCuentasList = this.$store.getters['bancoscuentas/selectList']
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información de cuentas bancarias.'));

      this.$store.dispatch('bancosmovimientostipos/getBancosMovimientosTiposSelect')
        .then(() => {
            vm.bancosMovimientosTipos = this.$store.getters['bancosmovimientostipos/bancosMovimientosTiposSelect']
            vm.bancosMovimientosTiposList = this.$store.getters['bancosmovimientostipos/bancosMovimientosTiposSelectList']
          })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información de tipos de movimiento.'));
    },
    bancoCuentaActualizada (bancoCuentaNombre) {
      let bancoCuenta = null;
      if (bancoCuentaNombre) {
        bancoCuenta = this.getSelected(this.bancosCuentas, bancoCuentaNombre);
      }
      this.seleccion.bancoCuenta = bancoCuenta;
    },
    bancoMovimientoTipoActualizado(bancoMovimientoTipoNombre) {
      let bancoMovimientoTipo = null;
      if (bancoMovimientoTipoNombre) {
        bancoMovimientoTipo = this.getSelected(this.bancosMovimientosTipos, bancoMovimientoTipoNombre);
      }
      this.seleccion.bancoMovimientoTipo = bancoMovimientoTipo;
    },
    seleccionarOpciones () {
      this.seleccion.bancoCuenta = this.bancoCuenta;
      this.seleccion.fechaDesde = this.fechaDesde;
      this.seleccion.fechaHasta = this.fechaHasta;
      this.seleccion.bancoMovimientoTipo = this.bancoMovimientoTipo;
      this.seleccionBancoCuenta = true;
    },
    aceptarSeleccion() {
      //console.log(this.seleccion);
      this.bancoCuenta = this.seleccion.bancoCuenta;
      this.fechaDesde = this.seleccion.fechaDesde;
      this.fechaHasta = this.seleccion.fechaHasta;
      this.bancoMovimientoTipo = this.seleccion.bancoMovimientoTipo;
      /* Guardamos la empresa actual (para inicializar al cambiar de empresa) */
      this.empresaId = this.$store.getters['user/empresaId'];

      this.paginaActual = 1;

      this.seleccionBancoCuenta = false;
      
      this.getBancosMovimientos(true);
    },
    cancelarSeleccion() {
      this.seleccionBancoCuenta = false;
    },
    actualizarCierre() {
      this.$refs.cierreModal.show();
    },
    closeCierres() {
      this.$refs.cierreModal.hide();
    },
    consultar (item) {
      this.$router.push({ name: 'BancoMovimientoData', 
                          params: { id: item.id }})
    },
    editar (item) {
      this.bancoMovimientoSeleccionadoId = item.id;
      this.$refs.movimientoModal.show();
      /*
      this.$router.push({ name: 'BancoMovimientoABM', 
                          params: { id: item.id }});
      */
    },
    saldoCuenta () {
      let bancoCuentaId = 0;
      if (this.bancoCuenta) {
        bancoCuentaId = this.bancoCuenta.id;
      }
      this.$router.push({ name: 'BancoCuentaSaldos', 
                          params: { id: bancoCuentaId }});
    },
    agregar () {
      if (this.bancoCuenta) {
        this.bancoMovimientoSeleccionadoId = 0;
        this.$refs.movimientoModal.show();
      } else {
        this.showModalMsj('Seleccione por favor la cuenta en primer término', null, null, 'light');
      }
      /*
      this.$router.push({ name: 'BancoMovimientoABM', 
                          params: { id: 0 }});
      */
    },
    updateMovimientos() {
      this.$refs.movimientoModal.hide();
      this.getBancosMovimientos();
    },
    closeMovimiento() {
      this.$refs.movimientoModal.hide();
    },

    agregarTransferencia () {
      if (this.bancoCuenta) {
        this.$refs.transferenciaCuentasModal.show();
      } else {
        this.showModalMsj('Seleccione por favor la cuenta en primer término', null, null, 'light');
      }
    },
    closeTransferencia(actualizar) {
      this.$refs.transferenciaCuentasModal.hide();
      if (actualizar) {
        this.getBancosMovimientos();
      }
    },

    agregarTransferenciaPremios () {
      if (this.bancoCuenta) {
        this.$refs.transferenciaPremiosModal.show();
      } else {
        this.showModalMsj('Seleccione por favor la cuenta en primer término', null, null, 'light');
      }
    },
    closeTransferenciaPremios(actualizar) {
      this.$refs.transferenciaPremiosModal.hide();
      if (actualizar) {
        this.getBancosMovimientos();
      }
    },

    borrar (item) {
      this.showModalConfirm('¿Desea borrar el movimiento seleccionado?', 
            this.borrarMovimiento.bind(this, item.id), 'Si', null, 'No')
    },
    borrarMovimiento (bancoMovimientoId) {
      this.showSpinner();
      this.$store.dispatch('bancosmovimientos/delete', bancoMovimientoId)
        .then(() => this.showModalMsj('El movimiento se borró con éxito', this.getBancosMovimientos, this.getBancosMovimientos, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    conciliar (item) {
      this.bancoMovimientoSeleccionado = item;
      this.$refs.conciliacionModal.show();
    },
    movimientoConciliado() {
      this.$refs.conciliacionModal.hide();
      this.getBancosMovimientos();
    },
    closeConciliacion() {
      this.$refs.conciliacionModal.hide();
    },
    anularConciliacion (item) {
      this.showModalConfirm('¿Desea anular la conciliación del movimiento seleccionado?', 
            this.anularConciliacionMovimiento.bind(this, item.id), 'Si', null, 'No')
    },
    anularConciliacionMovimiento (bancoMovimientoId) {
      this.showSpinner();
      this.$store.dispatch('bancosmovimientos/anularConciliacion', bancoMovimientoId)
        .then(() => this.showModalMsj('La conciliación se anuló con éxito', this.getBancosMovimientos, this.getBancosMovimientos, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    devolver (item) {
      this.showModalConfirm('¿Desea devolver el cheque propio seleccionado?', 
            this.devolverChequePropio.bind(this, item.id), 'Si', null, 'No')
    },
    devolverChequePropio (chequePropioId) {
      this.showSpinner();
      this.$store.dispatch('bancosmovimientos/devolverChequePropio', chequePropioId)
        .then(() => this.showModalMsj('Se registró la devolución del cheque con éxito', this.getBancosMovimientos, this.getBancosMovimientos, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    anularDevolucion() {
      this.$refs.anulacionDevolucionModal.show();
    },
    closeAnulacionDevolucion(actualizar) {
      this.$refs.anulacionDevolucionModal.hide();
      if (actualizar) {
        this.getBancosMovimientos();
      }
    },
    exportarLibroBanco() {
      this.showSpinner();
      this.$store.dispatch('bancosmovimientos/getBancosMovimientosRpt')
        .then(() => {
          let exportRpt = Boolean(false); 
          let libroBanco = this.$store.getters['bancosmovimientos/bancosMovimientosRpt'];
          if (libroBanco) {
            if (libroBanco.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            let params = {
              showSaldo: this.bancoMovimientoTipoId != 0 ? false : true,
              libroBanco
            }
            this.exportXLSLibroBanco(params);
          } else {
            this.showErrorMsj ('No hay información para exportar');
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally (() => this.hideSpinner())
    },

    // seleccionarMovimiento(item) {
    //   console.log(item);

    //   if (item.selected) {
    //     this.$store.dispatch('bancosmovimientos/anularSeleccionMovimiento', item.id);
    //   } else {
    //     this.$store.dispatch('bancosmovimientos/seleccionarMovimiento', item.id);
    //   }
    //   // item.selected = !item.selected;
    // },
    // cancelarSeleccion() {
    //   this.$store.dispatch('bancosmovimientos/cancelarSeleccionMovimientos');
    //   // this.bancosMovimientos.forEach(t => t.selected = false);
    // },

    seleccionarMovimiento(item) {
      this.$store.dispatch('bancosmovimientos/seleccionarMovimiento', item.id);
    },
    actualizarSeleccion(item) {
      this.$store.dispatch('bancosmovimientos/actualizarSeleccionMovimiento', item.id);
    },
    cancelarSeleccionMovimientos() {
      this.$store.dispatch('bancosmovimientos/cancelarSeleccionMovimientos');
    },
    conciliarMovimientos () {
      if (this.movimientosSeleccionados.length != 0) {
        this.bancoMovimientoSeleccionado = null;
        this.$refs.conciliacionModal.show();
      }
    },

    agregarCompraVentaDivisas () {
      if (this.bancoCuenta) {
        this.$refs.compraVentaDivisasModal.show();
      } else {
        this.showModalMsj('Seleccione por favor la cuenta en primer término', null, null, 'light');
      }
    },
    closeCompraVentaDivisas(actualizar) {
      this.$refs.compraVentaDivisasModal.hide();
      if (actualizar) {
        this.getBancosMovimientos();
      }
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getBancosMovimientos(); 
      }
    },    
  }    
}
</script>

<style>
  .bancos-movimientos-list .registro table td[aria-colindex="1"] {
    width: 12%;
  }
  .bancos-movimientos-list .registro table td[aria-colindex="2"] {
    width: Calc(32% - 60px)
  }
  .bancos-movimientos-list .registro table td[aria-colindex="3"] {
    width: 10%;
  }
  .bancos-movimientos-list .registro table td[aria-colindex="4"] {
    width: 12%;
  }
  .bancos-movimientos-list .registro table td[aria-colindex="5"] {
    width: 12%;
  }
  .bancos-movimientos-list .registro table td[aria-colindex="6"] {
    width: 12%;
  }
  .bancos-movimientos-list .registro table td[aria-colindex="7"] {
    width: 5%;
  }
  .bancos-movimientos-list .registro table td[aria-colindex="8"] {
    width: 60px;
  }

  .bancos-movimientos-list .registro table tr.table-read-only {
    color: rgba(35, 40, 44, 0.6);
  }

/*
  .card-body >>> table > tbody > tr > td {
    cursor: pointer;
  }
  #btn-filtro {
    position: absolute;
    top: 10px;
    left: calc(100% - 60px);
  }
*/
</style>
